import React, { useState } from "react";
import styled from "styled-components/macro";
// import { Power } from "react-feather";
import { useHistory } from "react-router-dom";
import { Tooltip, IconButton as MuiIconButton } from "@material-ui/core";
import { connect } from "react-redux";
import { LogoutUserThunk } from "../redux/LoginRedux/Action";
import { RiLogoutCircleRLine } from "react-icons/ri";
// import { Modal, Result } from "antd";
const IconButton = styled.button`
  width: 100%;
  background: #fae2db !important;
  color: #e55934;
  font-size: 14px;
  font-weight: 600 !important;
  padding: 7px;
  border-radius: 6px !important;
  outline: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5em;

  svg {
    width: 16px;
    height: 16px;
  }
`;

function UserDropdown({ LogoutUserThunk, active }) {
  const history = useHistory();

  // const [setsignOutModal, setSetsignOutModal] = useState(false);

  const handleSignOut = () => {
    LogoutUserThunk(history);
  };

  return (
    <React.Fragment>
      <Tooltip title="Logout">
        <IconButton
          onClick={() => handleSignOut()}
          color="inherit"
          disabled={active}
        >
          <RiLogoutCircleRLine /> Log out
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
}

export default connect(null, { LogoutUserThunk })(UserDropdown);
